import { css } from '@emotion/react'

const dropdownBtn = css`
  min-width: 136px;
  padding: 9px 16px;
  flex-shrink: 0;
`

const dropdownMenu = css`
  min-width: 136px;
`

export const styles = {
  dropdownBtn,
  dropdownMenu,
}
